export default __webpack_public_path__ + "i18n/translation-nl.367c6775.json";